import { EpcDecodedCycleCountList } from '@/api/receive';
import { useSelector } from '@/hooks/useSelector';
import React from 'react';

const useDecodedCycleCountRequestBody = (): Array<EpcDecodedCycleCountList> => {
  const { decodedItemsConfirmed } = useSelector(
    state => state.cycleCount.products
  );

  const body: Array<EpcDecodedCycleCountList> = React.useMemo(() => {
    return (
      decodedItemsConfirmed?.map(product => ({
        upcCodeDecoded: product.upcCode || '',
        epcDecodedQuantity: product.epcCodes.length || 0,
        epcDecoded:
          product.epcCodes.map(({ epcCode }) => {
            return {
              epcDecodedCode: epcCode,
            };
          }) || [],
      })) ?? []
    );
  }, [decodedItemsConfirmed]);

  return body;
};

export default useDecodedCycleCountRequestBody;
